/**
 * Stub for `@atomic/notifications-adapter` (+ `/react`) while notifications are
 * ON HOLD for LMNT (Jeff, 2026-10-09: not released here yet).
 *
 * app-shell 2.15.1+ imports the adapter unconditionally (its ClientNotifications
 * wrapper), but mounts it only when the host passes a `notifications` config —
 * which this app does not. Yarn 1 installs no peers, so without the package the
 * build cannot resolve the import at all. vite.config.ts aliases both entry
 * points here, for every build (deployed too), so the import resolves and the
 * feature stays absent. Remove the alias and install the real adapter when the
 * LMNT integration lands (ATO2-1319 follow-up, Vera's rollout).
 *
 * Only the surface app-shell imports is stubbed; nothing here ever executes.
 */
import type { ReactNode } from "react";

export type NotificationItem = Record<string, unknown>;
export type NotificationLayoutParts = Record<string, unknown>;

export function gatewayNotificationTransport(_fetch: unknown, _url: string): Record<string, unknown> {
  return {};
}

export function Notifications(props: { children?: ReactNode; [key: string]: unknown }) {
  return <>{props.children}</>;
}
